import axios from 'axios'
import {FC, useEffect, useState} from 'react'
import {Form, Modal, Spinner} from 'react-bootstrap'
import {toast} from 'react-toastify'
import {KTSVG} from '../../../../../_metronic/helpers'
import {Buffer} from 'buffer'
import {useTestWebhookMutation} from '../../../../../services/cellcast'

export enum TestSendWebhookModalMode {
  Mo,
  Dlr,
  OptOut,
}

export type TestSendWebhookModalProps = {
  show: boolean
  url: string
  mode: TestSendWebhookModalMode
  username: string
  password: string
  onClose: () => void
}

const defaultDlrPayload = {
  _id: '66b5b93b1e2c012dfe964000',
  status: 'delivered',
  type: 'send',
  sender: 'cellcast',
  receiver: '404846000',
}

const defaultMoPayload = {
  _id: '66b5b93b1e2c012dfe964000',
  status: 'delivered',
  type: 'receive',
  message: 'This is reply message',
  sender: '404000000',
  receiver: '404846000',
}

const defaultOptOutPayload = {
  _id: '66b5b93b1e2c012dfe964000',
  status: 'unsubscribed',
  type: 'optout',
  contact: '404000000',
}

const TestSendWebhookModal: FC<TestSendWebhookModalProps> = (props) => {
  const {show, url, mode, onClose} = props

  const [payload, setPayload] = useState('')

  const [testData, {isLoading}] = useTestWebhookMutation()

  const doSentTest = async () => {
    testData({
      payload,
      forwardUrl: url,
    }).then((res) => {
      if ('data' in res) {
        if (res.data?.error && Object.keys(res.data?.error).length > 0) {
          toast.error(res?.data?.message)
        } else {
          toast.success(res?.data?.message)
        }
      } else if ('error' in res) {
        toast.error(res.error?.toString())
      }
    })
  }

  useEffect(() => {
    if (mode === TestSendWebhookModalMode.Mo) {
      setPayload(JSON.stringify(defaultMoPayload))
    }

    if (mode === TestSendWebhookModalMode.Dlr) {
      setPayload(JSON.stringify(defaultDlrPayload))
    }

    if (mode === TestSendWebhookModalMode.OptOut) {
      setPayload(JSON.stringify(defaultOptOutPayload))
    }
  }, [mode])

  return (
    <Modal
      id='kt_modal_create_app'
      tabIndex={1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-700px'
      className='vh-100'
      show={show}
      onHide={onClose}
      onBackdropClick={onClose}
    >
      <div className='modal-header'>
        <h1>Test Send {mode === TestSendWebhookModalMode.Mo ? 'Receive' : mode === TestSendWebhookModalMode.Dlr ? 'Status' : 'Opt-Out'} Webhook</h1>
        <div className='btn btn-icon btn-sm' onClick={onClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
      </div>
      <div className='modal-body'>
        <Form>
          <Form.Group>
            <Form.Label>Payload</Form.Label>
            <Form.Control
              data-testid='inputPayloadTestSend'
              as='textarea'
              className='form-control form-control-lg form-control-solid'
              rows={3}
              onChange={(e) => setPayload(e.target.value)}
              value={payload}
            />
          </Form.Group>
        </Form>
        <div className='d-flex justify-content-end mt-10'>
          <div id='kt_drawer_chat_close'>
            <button
              type='button'
              onClick={onClose}
              className='btn btn-sm gray_bg_purple me-2 w-100px p-3 fw-500 me-2'
            >
              Close
            </button>
            <button
              data-testid='btnSendRequest'
              className='btn btn-sm btn-light btn-primary fw-500 w-150px p-3 border-primary'
              disabled={isLoading}
              onClick={doSentTest}
            >
              {isLoading ? <Spinner size='sm' animation='grow' /> : 'Send Request'}
              <div></div>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default TestSendWebhookModal
